export default __webpack_public_path__ + "static/media/ford.7beab6d7.ico";